import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Stack
} from '@mui/material';
import {
  Phone as PhoneIcon
} from '@mui/icons-material';

const CTA = () => {
  return (
    <Box 
      sx={{ 
        background: 'linear-gradient(135deg, #1976d2 0%, #dc004e 100%)',
        color: 'white',
        py: 10,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Background Pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          opacity: 0.3
        }}
      />

      <Container maxWidth="md" textAlign="center" sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h2" gutterBottom fontWeight={800}>
          Vakit Kaybetmeyin!
        </Typography>
        <Typography variant="h5" sx={{ mb: 2, opacity: 0.9 }}>
          Detaylı bilgi için bizimle hemen iletişime geçin
        </Typography>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: 700, color: '#FFD700' }}>
          +90 (212) 322 74 90
        </Typography>
        
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
          sx={{ mb: 4 }}
        >
          <Button 
            variant="contained" 
            size="large"
            sx={{ 
              bgcolor: 'white',
              color: 'primary.main',
              fontWeight: 700,
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              '&:hover': {
                bgcolor: 'grey.100',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Demo Talep Edin
          </Button>
          <Button 
            variant="outlined" 
            size="large"
            startIcon={<PhoneIcon />}
            sx={{ 
              borderColor: 'white',
              color: 'white',
              fontWeight: 600,
              px: 4,
              py: 1.5,
              '&:hover': {
                borderColor: 'white',
                bgcolor: 'rgba(255,255,255,0.1)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            Hemen Arayın
          </Button>
        </Stack>
        
        <Typography variant="body1" sx={{ opacity: 0.8 }}>
          Kurulum ve eğitim dahil • 7/24 teknik destek • Para iade garantisi
        </Typography>
      </Container>
    </Box>
  );
};

export default CTA;